import { createSlice } from "@reduxjs/toolkit";
import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";
import apiService from "../../services/api.service";
import { Sample } from "../../assets/images";

export const getProductList = createApiThunk(
  "getProductList",
  apiService.getProductList
);

export const getProductInfo = createApiThunk(
  "getProductInfo",
  apiService.getProductInfo
);

export const getCategoryList = createApiThunk(
  "getCategoryList",
  apiService.getCategoryList
);

export const initialData = {
  productListLoading: false,
  pproductInfoLoading: false,

  productList: [
    // {
    //   id: 1,
    //   label: "Carabiner Set",
    //   category: "Accessories",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   image: CarabinerSet,
    //   options: {
    //     color: [
    //       { label: "White", image: Sample },
    //       { label: "Red", image: Sample },
    //       { label: "Black", image: Sample },
    //     ],
    //     size: [
    //       { label: "XS" },
    //       { label: "S" },
    //       { label: "M" },
    //       { label: "L" },
    //       { label: "XL" },
    //       { label: "2XL" },
    //       { label: "3XL" },
    //     ],
    //   },
    //   price: 42.0,
    // },
    // {
    //   id: 2,
    //   // color: "#fae7e6",
    //   label: "Jaq Bag",
    //   category: "Accessories",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   image: JaqBag,
    //   options: {
    //     color: [
    //       { label: "White", image: Sample },
    //       { label: "Red", image: Sample },
    //       { label: "Black", image: Sample },
    //     ],
    //     size: [
    //       { label: "XS" },
    //       { label: "S" },
    //       { label: "M" },
    //       { label: "L" },
    //       { label: "XL" },
    //       { label: "2XL" },
    //       { label: "3XL" },
    //     ],
    //   },
    //   price: 12.0,
    // },
    // {
    //   id: 3,
    //   // color: "#f6d7f8",
    //   label: "Nanga Sandal",
    //   category: "Footwear",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   image: NangaSandal,
    //   options: {
    //     color: [
    //       { label: "White", image: Sample },
    //       { label: "Red", image: Sample },
    //       { label: "Black", image: Sample },
    //     ],
    //     size: [
    //       { label: "XS" },
    //       { label: "S" },
    //       { label: "M" },
    //       { label: "L" },
    //       { label: "XL" },
    //       { label: "2XL" },
    //       { label: "3XL" },
    //     ],
    //   },
    //   price: 89.0,
    // },
    // {
    //   id: 4,
    //   // color: "#cdcfeb",
    //   label: "Ponca Termos",
    //   category: "Accessories",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   tag: "60 pcs in a bottle",
    //   image: PoncaTermos,
    //   options: {
    //     color: [
    //       { label: "White", image: Sample },
    //       { label: "Red", image: Sample },
    //       { label: "Black", image: Sample },
    //     ],
    //     size: [
    //       { label: "XS" },
    //       { label: "S" },
    //       { label: "M" },
    //       { label: "L" },
    //       { label: "XL" },
    //       { label: "2XL" },
    //       { label: "3XL" },
    //     ],
    //   },
    //   price: 13.0,
    // },
    // {
    //   id: 5,
    //   // color: "#fbf1df",
    //   label: "Carabiner Set",
    //   category: "Accessories",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   image: CarabinerSet,
    //   price: 42.0,
    // },
    // {
    //   id: 6,
    //   // color: "#fae7e6",
    //   label: "Jaq Bag",
    //   category: "Accessories",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   image: JaqBag,
    //   price: 12.0,
    // },
    // {
    //   id: 7,
    //   // color: "#f6d7f8",
    //   label: "Nanga Sandal",
    //   category: "Footwear",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   image: NangaSandal,
    //   price: 89.0,
    // },
    // {
    //   id: 8,
    //   // color: "#cdcfeb",
    //   label: "Ponca Termos",
    //   category: "Accessories",
    //   description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.`,
    //   tag: "60 pcs in a bottle",
    //   image: PoncaTermos,
    //   price: 13.0,
    // },
  ],
  filterList: [
    {
      label: "Availability",
    },
    {
      label: "Price Range",
    },
  ],
  categoryList: [
    {
      id: 1,
      label: "Glowing",
      icon: "",
    },
    {
      id: 2,
      label: "Mood",
      icon: "",
    },
    {
      id: 3,
      label: "Sleep",
      icon: "",
    },
    {
      id: 4,
      label: "Vitamin",
      icon: "",
    },
  ],
  colorList: [
    {
      id: 1,
      value: "#ffc964",
    },
    {
      id: 2,
      value: "#ff766a",
    },
    {
      id: 3,
      value: "#ff80ea",
    },
    {
      id: 4,
      value: "#b4a6ff",
    },
    {
      id: 5,
      value: "#8fc9ff",
    },
    {
      id: 6,
      value: "#73eaf1",
    },
    {
      id: 7,
      value: "#5bf3d2",
    },
  ],
  materialList: [
    {
      id: 1,
      label: "Metal",
    },
    {
      id: 2,
      label: "Wood",
    },
    {
      id: 3,
      label: "Glass",
    },
    {
      id: 4,
      label: "Stone",
    },
    {
      id: 5,
      label: "Acrilic",
    },
  ],
  filteredProducts: [],
};

const dataSlice = createSlice({
  name: "product",
  initialState: initialData,
  reducers: {
    setFilteredProducts: (state, action) => {
      state.filteredProducts = action.payload;
    },
  },
  extraReducers: (builder) => {
    createApiCase(builder, getProductList, {
      loading: "productListLoading",
      fulfilled: (state, action) => {
        state.productList = action.payload.data.latest;
      },
    });
    createApiCase(builder, getProductInfo, {
      loading: "productInfoLoading",
      fulfilled: (state, action) => {
        state.productInfo = action.payload.data;
      },
    });
  },
});

export const { setFilteredProducts } = dataSlice.actions;

export default dataSlice.reducer;
